import * as React  from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';
import ActivityTitle from './activityTitle';
import ChangeRow from './changeRow';
import { getResolutionName } from '../utils';

/** A field-level change recorded against an Activity. */
export default function ActivityLog({ data, isPrintPreview }) {
    const change = data.change || {};
    const isResolutionChange = change.field === "Resolution";

    return(
        <div className="combinedListing detailListing">
            <div className="combinedCreatedDate detailCreatedDate">
                <ActorAvatar userId={data.actor_id} />
            </div>

            <div className="combinedRightBlock detailRightBlock resolutionChanged">
                    <div className="combinedDescription detailDescription">
                        <div className="alignMiddle mb mb__8 flexWrap">
                        <ActorName userId={data.actor_id} inner="header" />
                        <span className="dateTime mr">
                            <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                        </span>
                        {isResolutionChange ? <span className="mr">changed resolution of</span> : "edited activity"}
                        <ActivityTitle activity={data.activity} isPrintPreview={isPrintPreview} />
                    </div>
                </div>
                {isResolutionChange ? (
                    <p className="resolutionBlock">
                        From
                        <span className={`status ${getResolutionName((change.from_value || "").toLowerCase(), true)}`}> {change.from_value} </span>
                        to
                        <span className={`status ${getResolutionName((change.to_value || "").toLowerCase(), true)}`}> {change.to_value}</span>
                    </p>
                ) : (
                    <div className="update_information">
                        <ul className="logs_listing">
                            <ChangeRow change={data.change} />
                        </ul>
                    </div>
                )}
            </div>
        </div>
    )
}
